export class ObservacionDetalle {
    cobservacionCodtipo: string;
    cobservacionDsc: string;
    dobservacionFecharegistro: Date;
    nobservacionId: number;
    nobservacionIdtipo: number;
    nobservacionNumplazo: number;
    strDobservacionFecharegistro: string;
    cobservacionFlgactivo: string;
}
